<template>
  <div class="header-margin">
    <div class="d-none d-xl-block">
      <b-jumbotron bg-variant="transparent" class="top-block">
        <template #header>
          <div data-aos="fade-right" data-aos-duration="1500">
            <span class="header-title1">
              <span v-html="$t('header.title1')"></span>
            </span>
            <span class="header-title2">
              Cloud
            </span>
          </div>
        </template>
        <br>
        <div class="header-block">
          <p class="header-block-text">
            <span v-html="$t('header.subtitle')"></span>
          </p>
        </div>
        <br>
        <b-button variant="primary" class="button button--atlas" href="https://outlook.office365.com/owa/calendar/DimsiCloud@dimsi.fr/bookings/" target="_blank">
          <span>{{ $t('header.bookButton') }}</span>
          <div class="marquee" aria-hidden="true">
            <div class="marquee__inner">
              <span>{{ $t('header.bookButton') }}</span>
              <span>{{ $t('header.bookButton') }}</span>
              <span>{{ $t('header.bookButton') }}</span>
              <span>{{ $t('header.bookButton') }}</span>
            </div>
          </div>
        </b-button>
        <div class="fadingEffect"></div>
      </b-jumbotron><br>
      <div class="header-down-arrow">
        <img src="https://cssanimation.rocks/levelup/public/images/downarrow.png" width="50">
      </div>
    </div>
    <div class="d-block d-lg-block d-xl-none">
      <div style="display: block;" class="top-block-mobile" />
      <b-jumbotron bg-variant="transparent" >
        <template #header>
          <div data-aos="fade-right" data-aos-duration="1500">
            <span class="header-title1-mobile">
              <span v-html="$t('header.title1')"></span>
            </span>
            <span class="header-title2-mobile">
              Cloud
            </span>
          </div>
        </template>
        <br>
        <div class="header-block">
          <p class="header-block-text">
            <span v-html="$t('header.subtitle')"></span>
          </p>
        </div>
        <br>
        <b-button variant="primary" href="https://outlook.office365.com/owa/calendar/DimsiCloud@dimsi.fr/bookings/" target="_blank" block>
          {{ $t('header.bookButton') }}
        </b-button>
        <div class="fadingEffect"></div>
      </b-jumbotron>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      scrollPosition: null
    }
  },
  mounted () {
    window.addEventListener('scroll', this.updateScroll);
  },
  methods: {
    updateScroll() {
        this.scrollPosition = window.scrollY
    }
  }
}
</script>
